import { NovaMark } from '../components/ui';

const TICKS = [-3, -2, -1, 0, 1, 2, 3];

/** Sayı doğrusunda 404, ekranın çok dışında kalır: küçük bir matematik şakası. */
export function NotFound() {
  return (
    <main className="nf">
      <a className="brand nf-brand" href="/">
        <NovaMark size={34} />
        <span className="brand-name">Nova Class</span>
      </a>
      <p className="nf-code" aria-label="Hata 404">
        404
      </p>
      <h1>Bu sayfa sayı doğrusunun dışında kaldı</h1>
      <p className="muted">Aradığınız adres yok ya da taşınmış olabilir. Bir ders bağlantısı açtıysanız bağlantıyı öğretmeninizden yeniden isteyin.</p>
      <svg className="nf-line" viewBox="0 0 420 70" role="img" aria-label="Üzerinde sayfanın bulunamadığı bir sayı doğrusu">
        <line x1="10" y1="28" x2="410" y2="28" />
        <path d="M18 22 L10 28 L18 34 M402 22 L410 28 L402 34" fill="none" />
        {TICKS.map((n, i) => (
          <g key={n}>
            <line x1={60 + i * 50} y1="21" x2={60 + i * 50} y2="35" />
            <text x={60 + i * 50} y="56" textAnchor="middle">
              {n < 0 ? `−${-n}` : n}
            </text>
          </g>
        ))}
      </svg>
      <div className="nf-actions">
        <a className="btn btn-primary btn-lg" href="/">
          Ana sayfaya dön
        </a>
        <a className="btn btn-lg" href="/#derse-katil">
          Derse katıl
        </a>
      </div>
    </main>
  );
}
